import { createAppSlice } from "../../../store/createAppSlice";

interface UpsellState {
  actionCount: number;
}

const initialState: UpsellState = {
  actionCount: 0,
};

const upsellSlice = createAppSlice({
  name: "upsell",
  initialState,
  reducers: (create) => ({
    incrementActionCount: create.reducer((state) => {
      state.actionCount += 1;
    }),
  }),
  selectors: {
    getActionCount: (state) => state.actionCount,
  },
});

const { actions, selectors } = upsellSlice;

export { upsellSlice, actions, selectors };
